"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAppConfig = void 0;
var _appConfig2 = _interopRequireDefault(require("./components/_app-config"));
var _withLegacyGetProps = require("./components/with-legacy-get-props");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*
 * Copyright (c) 2022, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

let _appConfig = _appConfig2.default;

/**
 * If a user hasn't opted into a fetchStrategy, automatically
 * opt them into getProps – this maintains backward compatibility.
 *
 * @private
 */
const getAppConfig = () => {
  if (!_appConfig.initAppState) {
    _appConfig = (0, _withLegacyGetProps.withLegacyGetProps)(_appConfig);
  }
  return _appConfig;
};
exports.getAppConfig = getAppConfig;